export default __webpack_public_path__ + "static/media/307.0d40fa20.jpg";